import { render, staticRenderFns } from "./DateAndPeriodsTab.vue?vue&type=template&id=1bda7975&"
import script from "./DateAndPeriodsTab.vue?vue&type=script&lang=ts&"
export * from "./DateAndPeriodsTab.vue?vue&type=script&lang=ts&"
import style0 from "./DateAndPeriodsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports